<template>
  <PrintPage :pageNumber="pageNumber">
    <template v-slot:header>
      <slot>
        <PrintHeaderClientSlim :project="project" />
      </slot>
    </template>

    <div class="content-box">
      <div class="content-box-header">
        <h2>2. {{ $t('solarPanels') }}</h2>
      </div>
      <div class="two-column-grid"></div>
    </div>

    <AttachmentsPrintGrid
      :attachments="project.serviceStringPlanAttachments"
      fieldName="stringPlanAttachments"
      fieldDescription="stringPlanAttachments_description"
      :maxImages="4"
    />
    <AttachmentsPrintGrid
      :attachments="project.stringPlanAvailableState"
      fieldName="stringPlanAvailableState"
      fieldDescription="stringPlanAvailableState"
      :maxImages="4"
    />

    <div class="content-box">
      <div class="two-column-grid">
        <div>{{ $t('stringPlanAvailableState') }}</div>
        <div>{{ $t(project.serviceReport.stringPlanAvailableState) }}</div>
      </div>
    </div>

    <AttachmentsPrintGrid
      :attachments="project.serviceClampAreaAttachments"
      fieldName="clampAreaAttachments"
      :maxImages="4"
    />
    <AttachmentsPrintGrid
      :attachments="project.serviceAllPanelsVisibleAttachments"
      fieldName="allPanelsVisibleAttachments"
      :maxImages="4"
    />
  </PrintPage>
</template>

<script>
import PrintPage from '@/components/Print/PrintPage';
import PrintHeaderClientSlim from '@/components/Print/PrintHeaderClientSlim';
import AttachmentsPrintGrid from '@/components/Print/AttachmentsPrintGrid';
import { range } from '@/helpers/math.js';

export default {
  name: 'MeasurementPrintPage1',
  components: {
    PrintPage,
    PrintHeaderClientSlim,
    AttachmentsPrintGrid,
  },
  props: {
    project: null,
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },
  computed: {},
  methods: { range },
};
</script>
